<div class="container-fluid horario-semanal">

  <!-- BEGIN Mantenimiento Interno (wizard: MsDetalle = 'S') -->
  <div *ngIf="MsDetalle == 'S' && WsMsDataInterno != ''">
    <app-simple-ms [WsData]="WsMsDataInterno" (CerrarMsInterno)="EventoCerrarMSInterno($event)"></app-simple-ms>
  </div>
  <!-- END Mantenimiento Interno -->

  <ng-container *ngIf="WsMsDataInterno == ''">

    <!-- Encabezado + Toolbar -->
    <div class="hs-header">
      <div class="hs-titulo">{{ TituloPantalla || A04CDE }}</div>
      <div class="hs-acciones">
        <!-- <button *ngFor="let boton of toolbar" type="button"
          class="btn btn-sm hs-btn"
          [title]="boton.Tooltip || boton.boton"
          [ngStyle]="{ 'background-color': boton.class }"
          (click)="clickToolbar(boton)">
          <i class="fas {{ boton.icono }}" *ngIf="boton.icono"></i>
          {{ boton.boton }}
        </button> -->
      </div>
    
      <div class="hs-acciones">
        <button
          type="button"
          class="btn btn-sm hs-btn-pdf"
          [disabled]="cargando || sinDatos"
          (click)="imprimirHorario()">
          <i class="fas fa-print"></i>
          Imprimir / PDF
        </button>
      </div>
    </div>

    <!-- Rejilla -->
    <div class="hs-scroll" *ngIf="!cargando; else cargandoTpl">
      <div class="hs-grid" [style.grid-template-columns]="gridCols">

        <!-- Fila de encabezados: esquina + un titulo por dia -->
        <div class="hs-esquina">Hora</div>
        <div class="hs-dia-head" *ngFor="let col of columnas">{{ col.nombre }}</div>

        <!-- Columna de horas -->
        <div class="hs-col-horas">
          <div class="hs-hora" *ngFor="let slot of slots" [style.height.px]="ALTO_SLOT">
            <span>{{ slot.label }}</span>
          </div>
        </div>

        <!-- Una columna por dia: celdas de fondo + bloques posicionados -->
        <div class="hs-col-dia" *ngFor="let col of columnas">
          <div class="hs-slot" *ngFor="let slot of slots"
            [style.height.px]="ALTO_SLOT"
            [class.hs-slot-click]="hayInsert"
            (click)="clickVacio(col, slot)">
          </div>

          <div class="hs-bloque" *ngFor="let bloque of col.bloques"
            [ngStyle]="estiloBloque(bloque)"
            [class.hs-bloque-click]="permitir_click_lista == 'S'"
            [title]="tooltipBloque(bloque)"
            (click)="clickBloque(bloque)">
            <div class="hs-bloque-hora">{{ rangoBloque(bloque) }}</div>
            <div class="hs-bloque-tit">{{ bloque.titulo }}</div>
            <div class="hs-bloque-sub" *ngIf="bloque.subtitulo">{{ bloque.subtitulo }}</div>
            <div class="hs-bloque-det" *ngIf="bloque.detalle">{{ bloque.detalle }}</div>
          </div>
        </div>

      </div>

      <div class="hs-vacio" *ngIf="sinDatos">
        No se encuentra informacion para armar el horario.
      </div>
    </div>

    <ng-template #cargandoTpl>
      <div class="text-center py-4">
        <i class="fa fa-spinner fa-spin fa-2xl"></i>
        <div>Cargando horario...</div>
      </div>
    </ng-template>

  </ng-container>
</div>
